export const mapPreference = key => ({
  get() {
    return this.$store.state.preferences[key];
  },
  set(value) {
    this.$store.dispatch('preferences/set', {
      key,
      value,
    });
  },
});
